export default __webpack_public_path__ + "static/media/Chevron left@1.5xTD.eb08f7fa.svg";